export default __webpack_public_path__ + "static/media/299.e1111495.png";